import { render, staticRenderFns } from "./ScontrinoSemplificato.vue?vue&type=template&id=024c80b8&scoped=true&"
import script from "./ScontrinoSemplificato.vue?vue&type=script&lang=js&"
export * from "./ScontrinoSemplificato.vue?vue&type=script&lang=js&"
import style0 from "./ScontrinoSemplificato.vue?vue&type=style&index=0&id=024c80b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c80b8",
  null
  
)

export default component.exports